import { config } from 'src/config'
import {
  POST_TYPE_GUIDE,
  POST_TYPE_PAGE,
  POST_TYPE_BLOG_POST,
  POST_TYPE_PRODUCT_TEST,
  POST_TYPE_CATEGORY,
  POST_TYPE_PRODUCT,
} from 'src/constants'

import type { PostType } from 'src/types/Post'

const wordpressApiMapping: any = {
  [POST_TYPE_BLOG_POST]: 'posts',
  [POST_TYPE_GUIDE]: 'guide',
  [POST_TYPE_PAGE]: 'pages',
  [POST_TYPE_PRODUCT_TEST]: 'producttest',
  [POST_TYPE_CATEGORY]: 'sw_category',
  [POST_TYPE_PRODUCT]: 'products',
}

export const getWordpressUrl = (postType: PostType) => {
  if (!wordpressApiMapping[postType]) {
    throw new Error(`Cannot map article type "${postType}" to a Wordpress API URL.`)
  }

  return `${config.cmsHost}/wp-json/wp/v2/${wordpressApiMapping[postType]}`
}
